// have written code with the help of  npm module react-text-overflow-middle-ellipsis with changes : https://www.npmjs.com/package/react-text-overflow-middle-ellipsis
import { Component } from 'react'

interface Props {
  text: string
  className: string
  color?: string
  required?: boolean
}

class EllipsisMiddle extends Component<Props> {
  selfEl
  textEl
  el
  color = this.props.color ?? '#1A202C'

  resize = () => {
    this.forceUpdate()
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
    this.checkWidth.bind(this)()
  }

  componentDidUpdate() {
    this.checkWidth.bind(this)()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  checkWidth(fixLength?: number | undefined) {
    fixLength = fixLength ?? 0
    if (this.selfEl && this.textEl && this.el) {
      const parentEl = this.selfEl.parentElement
      const containerWidth = parentEl.getBoundingClientRect().width
      const textWidth = this.textEl.getBoundingClientRect().width
      let text = this.props.text
      if (textWidth > containerWidth) {
        const shouldCutLength = Math.ceil(
          ((textWidth - containerWidth) / textWidth) * text.length + fixLength,
        )
        const startIndex = Math.floor(text.length / 2 - shouldCutLength / 2)
        const endIndex = Math.ceil(text.length / 2 + shouldCutLength / 2)
        const start = text.substring(0, startIndex)
        const end = text.substring(endIndex, text.length)
        text = `${start}...${end}`
      }

      this.el.textContent = '...'
      const minWidth = this.el.getBoundingClientRect().width
      this.el.textContent = text

      const realWidth = this.el.getBoundingClientRect().width

      if (realWidth > containerWidth && realWidth > minWidth) {
        fixLength += 1
        this.checkWidth.bind(this)(fixLength)
      }
    }
  }

  render() {
    return (
      <div {...this.props} ref={el => (this.selfEl = el)}>
        <span
          style={{
            position: 'fixed',
            whiteSpace: 'nowrap',
            visibility: 'hidden',
            textOverflow: 'initial',
            color: `${this.color}`,
          }}
          ref={el => (this.textEl = el)}
        >
          {this.props.text}
        </span>
        <span
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'initial',
            color: `${this.color}`,
          }}
          ref={el => (this.el = el)}
        >
          &nbsp;
        </span>
        {this.props.required ? <span style={{color: '#ff0050'}}>*</span> : null}
      </div>
    )
  }
}

export default EllipsisMiddle
